export default __webpack_public_path__ + "static/media/efecty_icon.354c668a.png";